
'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function Analytics() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', 'G-H61VMB3KZT', {
        page_path: pathname,
      });
    }
  }, [pathname]);

  return null;
}
